import { defineStore } from "pinia";
import { ref } from "vue";

import { getAllEvents } from "../api/getAllEvents";
import { readAllEvents } from "../api/readAllEvents";
import { readEvent } from "../api/readEvent";
import { formatErrorNotification } from "../lib/formatErrorNotification";
import { normalizeNotifications } from "../lib/normalizeNotifications";

export const useNotificationsStore = defineStore("NotificationsStore", () => {
    const notify = ref(null);
    const notificationsList = ref([]);

    const setNotify = (newNotify) => {
        notify.value = newNotify;

        // Дедуп по id: один и тот же broadcast может долететь дважды
        // (ретрай воркера / повторная доставка) — в колокольчике не дублируем.
        const alreadyInList = notificationsList.value.some(
            (item) => item.id === newNotify.id
        );

        if (newNotify.id && !alreadyInList) {
            notificationsList.value.unshift(newNotify);
        }
    };

    const setErrorNotify = (error) => {
        notify.value = formatErrorNotification(error);
    };

    const resetNotify = () => {
        notify.value.shift();
    };

    const getNotifications = async () => {
        const notifications = await getAllEvents();

        notificationsList.value = normalizeNotifications(notifications);
    };

    const readAllNotifications = async () => {
        await readAllEvents();

        notificationsList.value = [];
    };

    const readNotification = async (id) => {
        await readEvent(id);

        notificationsList.value = notificationsList.value.filter(
            (notification) => notification.id !== id
        );
    };

    return {
        notify,
        notificationsList,

        setNotify,
        setErrorNotify,
        resetNotify,
        getNotifications,
        readAllNotifications,
        readNotification,
    };
});
